import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { editorCheckLabel } from "./editorCheckLabel.js";
import MakeOwner from "./make-owner.js";
import { withResponseErrorHandling } from './withResponseErrorHandling';
import { convertActionToCasper, convertActionToDisplay } from './helper';

// Display invited users in this component and also update those users
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ExistingInvite = function ExistingInvite(_ref) {
  var csrftoken = _ref.csrftoken,
    isAuthenticated = _ref.isAuthenticated,
    shareOnHide = _ref.shareOnHide,
    refreshData = _ref.refreshData,
    selfCanWrite = _ref.selfCanWrite,
    selfIsOwner = _ref.selfIsOwner,
    selfIsAdmin = _ref.selfIsAdmin,
    setNumLoading = _ref.setNumLoading,
    setError = _ref.setError,
    existingInvite = _ref.existingInvite,
    setExistingInvite = _ref.setExistingInvite,
    objPK = _ref.objPK,
    objType = _ref.objType,
    objMode = _ref.objMode,
    objOwnerName = _ref.objOwnerName,
    objOwnerEmail = _ref.objOwnerEmail,
    linkUUID = _ref.linkUUID,
    isSharingEnabled = _ref.isSharingEnabled,
    username = _ref.username;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMakeOwner = _useState2[0],
    setShowMakeOwner = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    makeOwnerThisInvite = _useState4[0],
    setMakeOwnerThisInvite = _useState4[1];
  var updateExistingInvite = function updateExistingInvite(invite, action) {
    var updatedExistingInvite = existingInvite.map(function (existingInvite) {
      return invite.uuid === existingInvite.uuid ? _objectSpread(_objectSpread({}, existingInvite), {}, {
        action: convertActionToCasper(action)
      }) : existingInvite;
    });
    setExistingInvite(updatedExistingInvite);
    withResponseErrorHandling(fetch("/api/v2/update/share/link/", {
      headers: _objectSpread(_objectSpread({}, isAuthenticated ? {
        'X-CSRFToken': csrftoken
      } : {}), {}, {
        'Content-Type': 'application/json'
      }),
      method: "PUT",
      body: JSON.stringify({
        pk: linkUUID,
        invited_users: updatedExistingInvite
      })
    }).then(function (res) {
      return res.json();
    }), 'updating user list', setNumLoading, setError).then(function (response) {
      if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
        refreshData();
      }
    });
  };
  var removeInvitedUser = function removeInvitedUser(invite) {
    var remainingInvited = existingInvite.filter(function (_ref2) {
      var uuid = _ref2.uuid;
      return uuid !== invite.uuid;
    });
    withResponseErrorHandling(fetch("/api/v2/update/share/link/", {
      headers: _objectSpread(_objectSpread({}, isAuthenticated ? {
        'X-CSRFToken': csrftoken
      } : {}), {}, {
        'Content-Type': 'application/json'
      }),
      method: "PUT",
      body: JSON.stringify({
        pk: linkUUID,
        invited_users: remainingInvited
      })
    }).then(function (res) {
      return res.json();
    }), 'removing user', setNumLoading, setError).then(function (response) {
      if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
        refreshData();
      }
    });
  };
  function getTitle(invite) {
    var convertedAction = convertActionToDisplay(invite.action);
    return convertedAction;
  }
  var processMakeOwner = function processMakeOwner(invite) {
    // First show make owner and pass the information 
    setShowMakeOwner(true);

    // Second set the invite user to passdown to make owner component
    setMakeOwnerThisInvite(invite);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(MakeOwner, {
      show: showMakeOwner,
      onHide: function onHide() {
        return setShowMakeOwner(false);
      },
      refreshData: refreshData,
      objType: objType,
      objPK: objPK,
      invite: makeOwnerThisInvite,
      setNumLoading: setNumLoading,
      setError: setError,
      csrftoken: csrftoken,
      isAuthenticated: isAuthenticated,
      shareOnHide: shareOnHide
    }), objOwnerEmail ? /*#__PURE__*/_jsx("div", {
      className: "custom-box normal-background-color",
      children: /*#__PURE__*/_jsx(Form, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            xs: 10,
            sm: 10,
            md: 10,
            lg: 10,
            xl: 10,
            children: /*#__PURE__*/_jsx("div", {
              className: "d-flex align-items-center existing-invite-email",
              children: objOwnerEmail === objOwnerName ? /*#__PURE__*/_jsx("span", {
                className: "owner-name-as-email",
                children: objOwnerEmail
              }) : objOwnerName && objOwnerEmail ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("span", {
                  className: "owner-name",
                  children: objOwnerName
                }), /*#__PURE__*/_jsx("span", {
                  className: "owner-email",
                  children: objOwnerEmail
                })]
              }) : /*#__PURE__*/_jsx("span", {
                className: "owner-name-as-email",
                children: objOwnerName || objOwnerEmail
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx("div", {
              className: "text-center",
              children: /*#__PURE__*/_jsx(Button, {
                variant: "custom-light remove-border",
                disabled: true,
                children: "Owner"
              })
            })
          })]
        })
      })
    }) : /*#__PURE__*/_jsx(Spinner, {
      animation: "border",
      variant: "secondary",
      size: "sm"
    }), existingInvite.map(function (invite, index) {
      return /*#__PURE__*/_jsx("div", {
        className: "custom-box hover-background-color",
        children: /*#__PURE__*/_jsx(Form, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              xs: 10,
              sm: 10,
              md: 10,
              lg: 10,
              xl: 10,
              children: /*#__PURE__*/_jsx("div", {
                className: "d-flex align-items-center existing-invite-email",
                children: invite.email === invite.user_name ? /*#__PURE__*/_jsx("span", {
                  className: "invitee-name-as-email",
                  children: invite.email
                }) : invite.user_name && invite.email ? /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "invitee-name",
                    children: invite.user_name
                  }), /*#__PURE__*/_jsx("span", {
                    className: "invitee-email",
                    children: invite.email
                  })]
                }) : /*#__PURE__*/_jsx("span", {
                  className: "invitee-name-as-email",
                  children: invite.user_name || invite.email
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsxs(DropdownButton, {
                id: invite.uuid,
                title: getTitle(invite),
                variant: "custom-light btn-block",
                "aria-expanded": "true",
                disabled: !isSharingEnabled,
                children: [/*#__PURE__*/_jsxs(Dropdown.Item, {
                  className: "white-space-normal",
                  disabled: getTitle(invite) !== 'Viewer' && selfCanWrite === false,
                  onClick: function onClick() {
                    return updateExistingInvite(invite, "Viewer");
                  },
                  children: ["Viewer ", editorCheckLabel(getTitle(invite) !== 'Viewer' && selfCanWrite === false)]
                }), /*#__PURE__*/_jsxs(Dropdown.Item, {
                  className: "white-space-normal",
                  disabled: selfCanWrite === false,
                  onClick: function onClick() {
                    return updateExistingInvite(invite, "Editor");
                  },
                  children: ["Editor ", editorCheckLabel(selfCanWrite === false)]
                }), /*#__PURE__*/_jsx(Dropdown.Divider, {}), invite.invited_user ? /*#__PURE__*/_jsxs(Dropdown.Item, {
                  className: "white-space-normal",
                  disabled: selfIsOwner === false && selfIsAdmin === false,
                  onClick: function onClick() {
                    return processMakeOwner(invite);
                  },
                  children: ["Make Owner ", editorCheckLabel(selfIsOwner === false && selfIsAdmin === false, 'Admin/Owner')]
                }) : null, /*#__PURE__*/_jsxs(Dropdown.Item, {
                  className: "white-space-normal",
                  disabled: invite.user_name !== username && selfCanWrite === false,
                  onClick: function onClick() {
                    return removeInvitedUser(invite);
                  },
                  children: ["Remove ", editorCheckLabel(invite.user_name !== username && selfCanWrite === false)]
                })]
              })
            })]
          })
        })
      }, index);
    })]
  });
};
export default ExistingInvite;